
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.542 5.59a.5.5 0 010-.71L4.07 2.378a.5.5 0 01.851.355v1.79h5.163a3.916 3.916 0 010 7.832H6.88a.712.712 0 010-1.424h3.204a2.492 2.492 0 000-4.984H4.92v1.79a.5.5 0 01-.851.355L1.542 5.59z","fill":"#282E3E"}})])
          )
        }
      }
    